
import manager from './manager';

export default manager;
